import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { AppExceptionModel } from '../../models/app-exception.model';
import { Podcast } from '../../models/podcast.model';
import * as podcastActions from '../actions/podcast.actions';

export interface PodcastState extends EntityState<Podcast> {
  selectedPodcastId: string | undefined;
  lastSearchKey: object | undefined | null;
  loading: boolean;
  loaded: boolean;
  inProgress: boolean;
  error: AppExceptionModel | undefined;
}

export const podcastAdapter: EntityAdapter<Podcast> =
  createEntityAdapter<Podcast>();

export const initialState: PodcastState = podcastAdapter.getInitialState({
  selectedPodcastId: undefined,
  lastSearchKey: undefined,
  loading: false,
  loaded: false,
  inProgress: false,
  error: undefined,
});

export const podcastReducer = createReducer(
  initialState,
  on(podcastActions.getPodcasts, (state, {}) => ({
    ...state,
    loading: true,
    loaded: false,
    error: undefined,
  })),
  on(podcastActions.getPodcast, (state, {}) => ({
    ...state,
    error: undefined,
  })),
  on(podcastActions.loadPodcast, (state, { podcasts, lastSearchKey }) => {
    if (podcasts.length > 0) {
      return podcastAdapter.addMany(podcasts, {
        ...state,
        lastSearchKey: lastSearchKey,
        loading: false,
        loaded: true,
        inProgress: false,
        error: undefined,
      });
    } else {
      return {
        ...state,
        loading: false,
        loaded: true,
        inProgress: false,
        error: undefined,
      };
    }
  }),
  on(podcastActions.getPodcastsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    loaded: true,
    error: error,
  })),
  on(podcastActions.create, (state, { podcast }) => ({
    ...state,
    error: undefined,
    inProgress: true,
  })),
  on(podcastActions.createSuccess, (state, { podcast }) =>
    podcastAdapter.addOne(podcast, {
      ...state,
      error: undefined,
      inProgress: false,
    }),
  ),
  on(podcastActions.createFailure, (state, { error }) => ({
    ...state,
    error: error,
    inProgress: false,
  })),
  on(podcastActions.update, (state, { podcast }) => ({
    ...state,
    error: undefined,
    inProgress: true,
  })),
  on(podcastActions.updateSuccess, (state, { podcast }) =>
    podcastAdapter.addOne(podcast, {
      ...state,
      error: undefined,
      inProgress: false,
    }),
  ),
  on(podcastActions.updateFailure, (state, { error }) => ({
    ...state,
    error: error,
    inProgress: false,
  })),
  on(podcastActions.deleteAction, (state, { id }) => ({
    ...state,
    error: undefined,
    inProgress: true,
  })),
  on(podcastActions.deleteSuccess, (state, { id }) =>
    podcastAdapter.removeOne(id, {
      ...state,
      error: undefined,
      inProgress: false,
    }),
  ),
  on(podcastActions.deleteFailure, (state, { error }) => ({
    ...state,
    error: error,
    inProgress: false,
  })),
  on(podcastActions.select, (state, { id }) => ({
    ...state,
    selectedPodcastId: id,
    error: undefined,
    inProgress: false,
  })),
  on(podcastActions.clear, (state) => initialState),
);
